<template>
    <section class="course-dop">

        <div class="col-12 kurs" v-if="showAdditionalPackage">
            <div :class="['dop-pack', {'activated' : activated}]">
                <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
                <div class="dop-pack-expand" v-if="!expanded" @click="expanded=true"><span>{{ $t('dop_pack_composition') }}</span></div>
                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_1') }}</div>
                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_2') }}</div>
                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_3') }}</div>
                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_4') }}</div>
                <div class="dop-pack-item" v-if="expanded">{{ $t('dop_pack_item_5') }}</div>
                <div class="dop-pack-price" v-if="(expanded || course.ordered)  && course.additional_package_price">
                    <span class="dop-pack-price-value">{{course.additional_package_price | formatPrice}}</span>&nbsp;<span
                        class="dop-pack-rub">{{ $t('cur') }}</span>
                    <span class="dop-pack-before" v-if="course.additional_package_price_before">{{course.additional_package_price_before | formatPrice}}&nbsp;{{ $t('cur') }}</span>
                </div>
                <div class="dop-pack-switch switch">
                    <label class="switch">
                        <input type="checkbox" v-model="activated">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import numeral from 'numeral';

    export default {
        name: 'CourseDop',

        props: {
            course: Object
        },

        data() {
            return {
                expanded: false,
                activated: false,
            }
        },
        watch: {
            activated() {
                this.$emit("additionalChange", this.activated);
            },
        },
        computed: {
            showAdditionalPackage() {
                return this.course.additional_package_enabled
                    && !this.course.isAdditionalPackage;
            },
        },
        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0").replace(/,/g,'\u00A0')
            }
        }
    }
</script>

<style scoped>
    .dop-pack-expand {
        font-size: 14px;
        color: #0489c7;
    }

    .dop-pack-expand span {
        border-bottom: 1px solid #0489c7;
        position: relative;
        cursor: pointer;
    }

    .dop-pack-expand span::after {
        display: block;
        content: ' ';
        height: 5px;
        width: 10px;
        background-image: url('~@/assets/hometeacher/images/expand-down-blue.png');
        position: absolute;
        right: -15px;
        top: 7px;
    }

    .dop-pack-price {
        margin-left: 0;
    }
</style>
